import styled from "styled-components";
import { COLORS } from "../../styles";

export const NP_Container = styled.div`
	padding: 20px 15px;
	background: ${COLORS.White};
	border-radius: 11px;
	min-height: 520px;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const NP_EmptyState = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
	max-width: 520px;
`;

export const NP_Bell = styled.div`
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 150px;
	height: 150px;
	margin-bottom: 24px;
	border-radius: 50%;
	background: rgba(216, 159, 91, 0.12);
	color: #d89f5b;
`;

export const NP_BellBadge = styled.div`
	position: absolute;
	top: 32px;
	right: 34px;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 30px;
	height: 30px;
	border-radius: 50%;
	background: #d89f5b;
	color: #fff;
	font-size: 16px;
	font-weight: 700;
`;

export const NP_Title = styled.h2`
	margin: 0;
	font-size: 28px;
	font-weight: 700;
	color: #191919;
`;

export const NP_Description = styled.p`
	margin: 14px 0 24px;
	font-size: 16px;
	line-height: 24px;
	color: #666;
`;

export const NP_Items = styled.div`
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 10px;
	width: 100%;

	@media (max-width: 640px) {
		grid-template-columns: 1fr;
	}
`;

export const NP_Item = styled.div`
	padding: 11px 14px;
	border: 1px solid rgba(216, 159, 91, 0.35);
	border-radius: 8px;
	background: rgba(216, 159, 91, 0.06);
	font-size: 14px;
	font-weight: 500;
	color: #555;
`;
